/* ==========================================================================
   sm-base.js — global, idempotent reveal-on-scroll observer for all
   sm-* sections. Loaded once via snippets/sm-base.liquid → theme.liquid.
   ========================================================================== */
window.smInitReveal = window.smInitReveal || function (root) {
  root = root || document;
  if (!window.__smIO) {
    window.__smIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('sm-in');
          window.__smIO.unobserve(e.target);
        }
      });
    }, {
      threshold: .05,
      // Expands the viewport box by 200px on the bottom edge, so sections
      // that start just below the fold (or near the top on load) reveal
      // right away instead of sitting hidden/"cut" until the user scrolls.
      rootMargin: '0px 0px 200px 0px'
    });
  }
  var els = root.querySelectorAll('.sm-reveal:not(.sm-in), .sm-reveal-stagger:not(.sm-in)');
  els.forEach(function (el) {
    window.__smIO.observe(el);
  });

  // Failsafe: if the observer somehow never fires for an element (slow image
  // load shifting layout, zero-height parent at observe-time, etc.), force
  // it visible after 1.5s instead of leaving it permanently hidden/"cut".
  window.setTimeout(function () {
    els.forEach(function (el) {
      if (!el.classList.contains('sm-in')) {
        el.classList.add('sm-in');
        if (window.__smIO) window.__smIO.unobserve(el);
      }
    });
  }, 1500);
};

document.addEventListener('DOMContentLoaded', function () { window.smInitReveal(); });
document.addEventListener('shopify:section:load', function (e) { window.smInitReveal(e.target); });